import React from "react";
import "../../OrderComponents/OrderTabs.css";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import api from "../../../seller-apis/api";

const EditStatusModal = ({
  show,
  handleUnlockClose,
  updateSatus,
  leadId,
  selectedPrice,
  status,
  statusObject,
}) => {
  const [other, setOther] = useState(false);
  const [error, setError] = useState(false);
  const [otherText,setOtherText] = useState("");
  const [selectedStatus,setselectedStatus] = useState("");
  const statusArray = ["OPEN", "FOLLOW_UP", "FORWARDED", "CONVERTED",
  "NOT_RELEVANT", "NOT_INTERESTED", "NO_RESPONSE"];
  const changeStatus = (value) => {
    setselectedStatus(value)
    if (value === "OTHER") {
      setOther(true);
    }
    else{
        setOther(false);
        setOtherText("");
    }
  }

  const updateStatus=() => {
    if(selectedStatus=='other' && otherText=="") {
      setError(true)
    }
    else{
      setError(false)
      updateSatus(leadId, selectedStatus, otherText)
    }
  }

  return (
    <Modal
      className="custom-modal1 lead-unlock"
      centered
      show={show}
      onHide={handleUnlockClose}
    >
      <div class="header-pop mb-1">
        <div class="header-title">Change Status</div>
        <a class="close-pop" onClick={() => handleUnlockClose()}>
          ×
        </a>
      </div>
      <Modal.Body>
        <div className="edit-lead-status">
          <div>
            <div class="form-check">
              
              <label class="form-check-label tv-color" for="exampleCheckbox">
                Mark Status as
              </label>
            </div>
            <div className="status-box">
              {/* <select class="form-select" aria-label="Default select example" onChange={(e) => changeStatus(e.target.value)}> */}
                {statusArray.map((status) => (
                  <>
                        <div class="form-check" onClick={()=>changeStatus(status)}>
                            <input class="form-check-input" name={'lead-status'} type="radio" value={status} id={status} />
                            <label class="form-check-label" for={status}>
                            {status.replace('_',' ')}
                            </label>
                            </div>
                  </>
                ))}
                <div class="form-check" onClick={(e)=>changeStatus('OTHER')}>
                    <input class="form-check-input" type="radio" name={'lead-status'} value={'OTHER'} id="flexCheckDefaultother" />
                    <label class="form-check-label" for="flexCheckDefaultother">
                        Other
                    </label>
                </div>
              {/* </select> */}
            </div>
            {other ? (
              <div className="textarea">
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  placeholder="Add text for other status"
                  onChange={(event) => setOtherText(event.target.value)}
                ></textarea>
                {error ?<p className="error" style={{marginTop:'auto !important'}}>{"Please enter a valid text"}</p>:""}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="text-center my-3">
            
          <button
            className="apply-btn px-3 fs-12"
            onClick={() => updateStatus()}
            disabled={!selectedStatus}
          >
            Update
          </button>
        </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditStatusModal;
